<template>
  <div class="table-container">
    <h5 v-if="title">{{ title }}</h5>

    <div class="table-responsive">
      <table
        :id="id"
        :style="{ width: '100%', textAlign: 'center' }"
        class="display table table-striped table-bordered"
      >
        <thead>
          <tr>
            <th
              v-for="(header, index) in normalizedHeaders"
              :key="index"
              :style="header.width ? { width: header.width } : {}"
            >
              {{ header.label }}
            </th>
            <th v-if="buttons.length">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-if="processedData && processedData.length"
            v-for="(row, rowIndex) in processedData"
            :key="rowIndex"
          >
            <td v-for="(cell, cellIndex) in row" :key="cellIndex">
              {{ cell }}
            </td>
            <td v-if="buttons.length">
              <button
                class="btn rounded d-flex flex-column justify-content-center align-items-center w-100 mb-2 text-center"
                v-for="(button, buttonIndex) in buttons"
                :key="buttonIndex"
                :disabled="button.disabled"
                :class="`btn-${button.color}`"
                @click="button.action(data[rowIndex])"
              >
                {{ button.label }}
              </button>
            </td>
          </tr>
          <tr v-else class="text-center text-muted">
            <td colspan="100%" style="text-align: center;">
              No data available
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <div v-else class="no-data">
        <p>No data available</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "TableComponent",

  props: {
    title: {
      type: String,
      default: ""
    },
    fields: {
      type: Array,
      default: () => [],
      required: true
    },
    headers: {
      type: Array,
      default: () => [],
      required: true
    },
    data: {
      type: Array,
      default: () => [],
      required: true
    },
    id: {
      type: String,
      default: "",
      required: false
    },

    buttons: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  computed: {
    normalizedHeaders() {
      return this.headers.map(header =>
        typeof header === "string" ? { label: header } : header
      );
    },
    processedData() {
      if (!this.data || this.data.length === 0) {
        return [];
      }
      return this.data.map((item, rowIndex) =>
        this.fields.map(field => {
          if (field === "index") {
            return String(rowIndex + 1);
          }

          const keys = field.split(".");

          let value = item;

          for (let key of keys) {
            if (
              value === null ||
              value === undefined ||
              typeof value !== "object"
            ) {
              return "-";
            }

            value = value[key];

            if (value === null || value === undefined) {
              return "-";
            }
          }
          return value !== null && value !== undefined ? String(value) : "-";
        })
      );
    }
  }
};
</script>

<style scoped>
.no-data {
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
  color: #666;
}
</style>
